import { render, staticRenderFns } from "./CloudLab.vue?vue&type=template&id=6ccc381e&scoped=true&"
import script from "./CloudLab.vue?vue&type=script&lang=js&"
export * from "./CloudLab.vue?vue&type=script&lang=js&"
import style0 from "./CloudLab.vue?vue&type=style&index=0&id=6ccc381e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc381e",
  null
  
)

export default component.exports